import React, { useEffect } from "react";
import styled from "styled-components";
import Button from "~/components-shared/Button";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { useDispatch, useSelector } from "react-redux";
import { MemberStatusEnum, RoutesEnum, StatusStateEnum } from "~/types/enums";
import Modal from "~/components-shared/Modal";
import memberSchema from "~/forms/MemberForm/memberSchema";
import toastsActionCreators from "~/store/toasts/actions";
import { useHistory } from "react-router-dom";
import { Alert } from "~/components-shared";
import manageCompaniesActionCreators from "~/store/manageCompanies/actions";
import manageCompanySelectors from "~/store/manageCompanies/selectors";
import ManageCompanyMemberForm from "~/forms/ManageCompanyMemberForm";
const Form = styled.form`
  width: 100%;
  display: flex;
  flex-direction: column;
  height: 100%;
`;
const ManageCompanyMemberUpdateModal = () => {
  const {
    t
  } = useTranslation();
  const company = useSelector(manageCompanySelectors.getSelected);
  const member = useSelector(manageCompanySelectors.getSelectedData);
  const memberId = member?.id || "";
  const status = useSelector(manageCompanySelectors.getStatusByMember(memberId));
  const error = useSelector(manageCompanySelectors.getErrorByMember(memberId));
  const history = useHistory();
  const dispatch = useDispatch();
  const defaultValues = {
    status: member?.status || MemberStatusEnum.ACTIVE,
    roleId: member?.role.id || "",
    department: member?.department,
    level: member?.level,
    authorities: member?.authorities || [],
    pendingIntegrationChannels: member?.settings?.pendingIntegrationChannels || false
  };
  const {
    handleSubmit,
    control,
    reset,
    watch,
    setValue
  } = useForm({
    resolver: yupResolver(memberSchema),
    defaultValues
  });
  useEffect(() => {
    if (member) {
      reset(defaultValues);
    }
  }, [memberId]);
  const onSubmit = handleSubmit(data => {
    if (company) {
      dispatch(manageCompaniesActionCreators.updateMemberStarted(company.id, memberId, data, _ref => {
        let {
          data: newMember
        } = _ref;
        if (newMember) {
          dispatch(toastsActionCreators.pushed({
            severity: "success",
            message: t("ManageCompanyMemberUpdateModal.memberUpdated", {
              name: `${member.firstName} ${member.lastName}`
            }),
            timeout: 10000,
            actions: [{
              icon: "external-link",
              onClick: () => history.push(RoutesEnum.MEMBER.replace(":memberId", newMember.id))
            }]
          }));
        }
      }));
    }
  });
  const handleCancel = () => {
    dispatch(manageCompaniesActionCreators.actionChanged(null, null));
  };
  return /*#__PURE__*/React.createElement(Modal.Body, {
    title: t("ManageCompanyMemberUpdateModal.updateMember"),
    onClose: handleCancel,
    maxWidth: "560px",
    fullWidth: true,
    fullHeight: true
  }, /*#__PURE__*/React.createElement(Form, {
    onSubmit: onSubmit
  }, /*#__PURE__*/React.createElement(Modal.Content, null, error && /*#__PURE__*/React.createElement(Alert, {
    severity: "danger",
    s: {
      mb: 3
    },
    fullWidth: true
  }, error), /*#__PURE__*/React.createElement(ManageCompanyMemberForm, {
    roles: company?.roles || [],
    control: control,
    watch: watch,
    setValue: setValue
  })), /*#__PURE__*/React.createElement(Modal.Actions, null, /*#__PURE__*/React.createElement(Button, {
    color: "transparent",
    s: {
      px: 8
    },
    onClick: handleCancel,
    rounded: true
  }, t("common.actions.cancel")), /*#__PURE__*/React.createElement(Button, {
    color: "primary",
    type: "submit",
    maxWidth: "230px",
    onClick: onSubmit,
    s: {
      ml: 2
    },
    loading: status === StatusStateEnum.LOADING,
    fullWidth: true,
    rounded: true
  }, t("ManageCompanyMemberUpdateModal.saveMember")))));
};
export default ManageCompanyMemberUpdateModal;